import React, { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Form,
  Image,
  Input,
  Row,
  Select,
  Upload,
  message,
} from 'antd';
import { Icons } from '../../../controller/Images';
import { CloseOutlined, RightOutlined } from '@ant-design/icons';
import { countryData } from '../../../data/countryCode';
import axios from 'axios';
import { getKeySkill } from '../../../controller/api/globalServices';
import { craeteCandidate, getCandidateByEmail } from '../../../controller/api/candidateServices';
import { getCandidateId, setCandidateDetail, setCandidateId } from '../../../controller/localStroageHandler';
const { Dragger } = Upload;
const Information = ({ current, setCurrent, setFormData }) => {
  const [fileList, setFileList] = useState([]);
  const [selectTechnology, setSelectTechnology] = useState([]);
  const [technologyList, setTechnologyList] = useState([]);
  const [city, setCity] = useState([]);
  const [form] = Form.useForm();
  const [btnloading, setbtnLoading] = useState(false)
  const { Option } = Select;
  let experienceOptions = [
    { year: '0-1', id: '0-1' },
    { year: '1-2', id: '1-2' },
    { year: '2-3', id: '2-3' },
    { year: '3-4', id: '3-4' },
    { year: '4-5', id: '4-5' },
    { year: '5-6', id: '5-6' },
    { year: '6-7', id: '6-7' },
    { year: '7-8', id: '7-8' },
    { year: '8-9', id: '8-9' },
    { year: '9-10', id: '9-10' },
    { year: '10+', id: '10+' },
  ];

  // const selectBefore = (
  //   <Form.Item
  //     name='countryCode'
  //     className='form-item'
  //     rules={[
  //       {
  //         required: true,
  //         message: 'Please input your Country code!',
  //       },
  //     ]}
  //     noStyle
  //   >
  //     <Select
  //       showSearch
  //       placeholder='country code'
  //       className='border-0 border-bottom custom-font-family-poppins'
  //       style={{ width: 72 }}

  //     >
  //       {countryData.map((val, index) => {
  //         return (
  //           <Option value={val.code} key={index}>
  //             {val.code}
  //           </Option>
  //         );
  //       })}
  //     </Select>
  //   </Form.Item>
  // );

  const props = {
    name: 'file',
    multiple: false,
    accept: ".pdf,.doc,.docx,.txt",
    fileList: fileList,
    beforeUpload: async (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => {
      setFileList([]);
    },
  };
  const chackCandidateAlready = async (email) => {
    let candidate = await getCandidateByEmail({ email: email })
    if (candidate?.data?.data) {
      setCandidateId(candidate?.data?.data?._id)
      setCandidateDetail(JSON.stringify(candidate?.data?.data))
      setCurrent(1);
      message.info('You already registered with this email. contuine to next step');
    }
  }
  useEffect(() => {
    const candidateEmail = localStorage.getItem('candidate_Email');
    form.setFieldsValue({ email: candidateEmail });
    const candidateID = getCandidateId();
    chackCandidateAlready(candidateEmail)
    if (candidateID) {
      setCurrent(1);
    }
    getKeyskilldata({ search: '' });
    axios
      .get('https://api.countrystatecity.in/v1/countries/IN/cities', {
        headers: {
          'X-CSCAPI-KEY':
            'aE16ZUEzQ1dqQzlMbkpIY0ZIQnNSZHdnWEM5dnBpeENFUWd3bEJjRQ==',
        },
      })
      .then((res) => {
        setCity(res?.data);
      })
      .catch((err) => {
        console.log(err, 'errr');
      });
  }, []);
  const getKeyskilldata = async (params) => {
    await getKeySkill(params).then(res => {
      setTechnologyList(res?.data?.result)
    }).catch(err => {
      console.log("err ===>", err)
    })

  }
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handleSubmit = async (values) => {
    // setbtnLoading(true)
    // setCurrent((prev) => prev + 1);
    setbtnLoading(true)
    console.log(values, "values");
    const payload = {
      email: values.email,
      firstName: values.first_name,
      lastName: values.last_name,
      phoneNo: values.phone,
      location: values?.location,
      experience: values?.experience,
      keySkills: selectTechnology.map((tech) => tech._id),
      instituteName: values.institute_name,
      resumeUrl: values.resume.file,
    };

    const formData = new FormData();
    formData.append('email', payload.email);
    formData.append('firstName', payload.firstName);
    formData.append('lastName', payload.lastName);
    formData.append('phoneNo', payload.phoneNo);
    formData.append('experience', payload.experience);
    formData.append('location', payload.location);
    formData.append('instituteName', payload?.instituteName);
    formData.append('resume', payload?.resumeUrl);
    formData.append('keySkills', JSON.stringify(payload?.keySkills));
    // payload?.keySkills?.forEach((val, index) => {
    //   return formData.append('keySkills', val);
    // });

    if (payload?.keySkills?.length == 0) {
      return message.info('Please Add minimum 1 Key Skill');
    }

    await craeteCandidate(formData).then((res) => {
      console.log('res====> djbdj', res);
      setCandidateId(res.data?.data?._id)
      setCandidateDetail(JSON.stringify(res.data?.data))
      setbtnLoading(false)
      message.success(res?.data?.message)
      setCurrent((prev) => prev + 1);
    }).catch((err) => console.log('err===== > ', message.error(err?.response?.data?.message))).finally(() => setbtnLoading(false))
    // await candidateDetails(formData)
    //   .then((res) => {
    //     localStorage.setItem('userID', res.data.user.id);
    //     localStorage.setItem('userdetail', JSON.stringify(res.data));
    // setbtnLoading(false)
    // setCurrent((prev) => prev + 1);
    //   })
    //   .catch((err) => console.log('err===== > ', err)).finally(()=>setbtnLoading(false))
  };


  const enterOnlyNumber = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp('[0-9]').test(keyValue);
    // const isValidecimal = new RegExp(".").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };
  const enterOnlyNumberWithdot = (event) => {
    const keyCode = event.which || event.keyCode;
    const keyValue = String.fromCharCode(keyCode);
    const isValid = new RegExp('[0-9.]').test(keyValue);
    // const isValidecimal = new RegExp(".").test(keyValue);
    if (!isValid) {
      event.preventDefault();
      return;
    }
  };
  return (
    <div className='w-100 h-100 information-form-page custom-font-family-poppins'>
      <div className='step-text'>
        <span className='text-color-custom fw-bold '>Step {current + 1} </span>
        of 2
      </div>
      <span className='title '>Introduce Your Self! </span>
      <div className='information-form-container mt-4'>
        <Row className='information-form  d-flex flex-column'>
          <Form
            form={form}
            initialValues={{
              countryCode: countryData.length > 0 ? countryData[0].code : undefined
            }}
            layout='vertical'
            onFinish={handleSubmit}
          // encType='multipart/form-data'
          >
            <Row gutter={[24, 0]}>
              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='first_name'
                  className='form-item'
                  label='First Name'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the First Name',
                    },
                  ]}
                >
                  <Input
                    className='border-0 border-bottom custom-font-family-poppins rounded-0'
                    placeholder='Enter Your First Name'
                  />
                </Form.Item>
              </Col>

              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='last_name'
                  className='form-item'
                  label='Last Name'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the Last Name',
                    },
                  ]}
                >
                  <Input
                    className='border-0 border-bottom rounded-0 custom-font-family-poppins'
                    placeholder='Enter Your Last Name'
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 0]}>
              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='phone'
                  className='form-item form-item-with-addon'
                  label='Phone No'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the Phone Number',
                    },
                  ]}
                >
                  <Input
                    className='border-0 border-bottom custom-font-family-poppins'
                    placeholder='Enter Your Number'
                    maxLength={10}
                    min={10}
                    // addonBefore={selectBefore}
                    onKeyPress={(event) => enterOnlyNumber(event)}
                  />
                </Form.Item>
              </Col>
              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='email'
                  className='form-item'
                  label='Email ID'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the Email',
                    },
                  ]}
                >
                  <Input
                    disabled
                    style={{ color: 'rgba(0, 0, 0, 0.75)' }}
                    className='border-0 border-bottom custom-font-family-poppins'
                    placeholder='Enter Your Email'
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 0]}>
              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='location'
                  className='form-item'
                  label='Location'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter Your Location',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder='Location'
                    className='border-0 border-bottom custom-font-family-poppins'
                  >
                    {city.map((val, index) => {
                      return (
                        <Option value={val.name} key={index}>
                          {val.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={7} md={7} sm={11} xs={24}>
                <Form.Item
                  name='experience'
                  className='form-item'
                  label='Experience  '
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter Your Experience  ',
                    },
                  ]}
                >
                  {/* <Input
                    className='border-0 border-bottom rounded-0 custom-font-family-poppins'
                    placeholder='Enter Your Experience '
                    onKeyPress={(event) => enterOnlyNumberWithdot(event)}
                  /> */}
                  <Select
                    showSearch
                    placeholder='Enter Your Experience'
                    className='border-0 border-bottom custom-font-family-poppins'
                  >
                    {experienceOptions.map((val, index) => {
                      return (
                        <Option value={val.id} key={index}>
                          {val.year} year
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[24, 0]} className='mb-3'>
              <Col lg={14} md={14} sm={22} xs={24}>
                <div className='border border-0 border-bottom d-flex p-1 flex-column custom-font-family-poppins'>
                  <span className='key-skill-label custom-font-family-poppins'>
                    <span className='text-danger'>* </span>Key Skills
                  </span>
                  <div className='d-flex gap-2 flex-wrap'>
                    {selectTechnology?.map((val, index) => {
                      return (
                        <span
                          key={index}
                          className='skill-bg-color text-muted rounded-1 d-flex justify-content-center align-items-center gap-1'
                          style={{ fontSize: '14px', padding: '0px 5px' }}
                        >
                          {val?.name}
                          <CloseOutlined
                            onClick={() => {
                              const data = selectTechnology?.filter(
                                (item) => val._id !== item._id
                              );
                              setSelectTechnology(data);
                            }}
                          />
                        </span>
                      );
                    })}
                    <span>
                      <Input
                        className='border border-0  text-black-50 fw-medium option-input custom-font-family-poppins'
                        placeholder='add technology '
                        onChange={(e) => getKeyskilldata({ search: e.target.value })}
                      />
                    </span>
                  </div>
                </div>
                <div className='d-flex gap-2 flex-wrap p-1'>
                  {technologyList?.map((val, index) => {
                    return (
                      <span
                        key={index}
                        className='skill-bg-color text-muted rounded-1 d-flex gap-1 '
                        style={{
                          letterSpacing: '0.30000001192092896px',
                          fontSize: '14px',
                          padding: '0px 5px',
                          cursor: 'pointer',
                        }}
                        onClick={() => {
                          let checkTechology = selectTechnology.filter(
                            (item) => val._id == item._id
                          );
                          if (checkTechology?.length) {
                            message.info(
                              'You Already Selected This Technology'
                            );
                          } else {
                            setSelectTechnology([...selectTechnology, val]);
                          }
                        }}
                      >
                        {val?.name}
                      </span>
                    );
                  })}
                </div>
              </Col>
            </Row>
            <Row gutter={[24, 0]}>
              <Col lg={14} md={14} sm={22} xs={24}>
                <Form.Item
                  name='institute_name'
                  className='form-item'
                  label='Institute Name?'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the Institute Name',
                    },
                  ]}
                >
                  <Input
                    className='border-0 border-bottom rounded-0 custom-font-family-poppins '
                    placeholder='XYZ Name'
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row span={16}>
              <Col lg={fileList?.length ? 8 : 8} md={15} sm={16} xs={24}>
                <Form.Item
                  name='resume'
                  className='form-item custom-font-family-poppins'
                  label='Upload Your Resume'
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter the Resume',
                    },
                  ]}
                >
                  <Dragger
                    className={`${fileList?.length && 'remove-dash'
                      } custom-font-family-poppins`}
                   
                    {...props}
                  >
                    {fileList?.length ? (
                      'Change'
                    ) : (
                      <Row gutter={[12, 3]}>
                        <Col xl={8} lg={8} md={8} sm={24} xs={24}>
                          <Image src={Icons.upload} alt='' preview={false} />
                        </Col>
                        <Col
                          xl={14}
                          lg={14}
                          md={14}
                          sm={24}
                          xs={24}
                          className=' opacity-50'
                        >
                          Drop Your file Here or{' '}
                          <span className='text-gray fw-bold'>Browser</span>
                          
                        </Col>
                        <Col span={24} className='text-gray opacity-50 ' style={{fontSize:'0.8rem'}}>
                          Supported File .pdf .doc .docx .txt</Col>
                        
                      </Row>
                    )}
                  </Dragger>
                </Form.Item>
              </Col>
            </Row>

            <Row span={24} className='mt-2'>
              <Col lg={4} md={8} sm={10} xs={14}>
                <Button
                  type='primary'
                  htmlType='submit'
                  loading={btnloading}
                  className='w-100 h-auto button-color p-2 d-flex justify-content-center align-items-center'
                >
                  Continue <RightOutlined />
                </Button>
              </Col>
            </Row>
          </Form>
        </Row>
      </div>
    </div>
  );
};

export default Information;
